import { Link } from "react-router-dom";
import { fears } from "../data/fears";

const wings = [
  { name: "Unknown Wing", category: "Unknown", note: "Unseen, unclear, or hard to name." },
  { name: "Social Wing", category: "Social", note: "Belonging, exposure, and other people." },
  { name: "Existential Wing", category: "Existential", note: "Time, meaning, memory, and endings." },
  { name: "Control Wing", category: "Control", note: "Uncertainty, change, and holding things together." },
  { name: "Physical Wing", category: "Physical", note: "The body, danger, scale, and vulnerability." }
];

function MuseumMap({ category }) {
  const activeWing = wings.find((wing) => wing.category === category);

  return (
    <aside className="glass-panel rounded-lg p-5">
      <p className="text-xs uppercase tracking-[0.28em] text-museum-gold">You are here</p>
      <h2 className="mt-3 font-display text-2xl text-museum-bone">{activeWing?.name || "Gallery Hall"}</h2>
      <p className="mt-3 text-sm leading-7 text-museum-muted">
        The map groups rooms by the kind of fear they explore, so this room has a place inside the wider exhibition.
      </p>
      <div className="mt-5 grid gap-3">
        <Link
          to="/#gallery"
          className="rounded-md border border-museum-bone/10 bg-museum-black/35 p-4 text-sm text-museum-muted transition hover:border-museum-gold/50 hover:text-museum-bone"
        >
          <span className="block font-display text-lg text-museum-bone">Gallery Hall</span>
          <span className="mt-1 block">All {fears.length} rooms in one place.</span>
        </Link>
        {wings.map((wing) => {
          const count = fears.filter((fear) => fear.category === wing.category).length;
          const isActive = wing.category === category;

          return (
            <div
              key={wing.category}
              className={`rounded-md border p-4 text-sm ${
                isActive
                  ? "border-museum-gold bg-museum-gold/12 text-museum-bone"
                  : "border-museum-bone/10 bg-museum-black/35 text-museum-muted"
              }`}
            >
              <div className="flex items-center justify-between gap-3">
                <span className="font-display text-lg">{wing.name}</span>
                <span className="text-xs uppercase tracking-[0.18em]">{count} rooms</span>
              </div>
              <p className="mt-2 leading-6">{wing.note}</p>
              {isActive && <p className="mt-3 text-xs uppercase tracking-[0.22em] text-museum-gold">Current wing</p>}
            </div>
          );
        })}
      </div>
    </aside>
  );
}

export default MuseumMap;
